import * as React from 'react';
import { Button, Collapse, Row, Col } from 'antd';
import { observer } from 'mobx-react';
import { isArrayLike } from 'mobx';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { DateView } from 'src/core/ui/date.view';
import { TextView } from 'src/core/ui/text.view';
import { IdentityService } from 'src/core/services/identity.service';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { VisibilityEditorView } from 'src/app/shared/parts/visibility-editor.view';

const Panel = Collapse.Panel;

interface NoteListViewProps extends ComponentViewProps<NoteItem[]> {
	parentMode: ControlMode;
	identityService: IdentityService;
	deleteNote: (noteDelete: NoteItem, parent: NoteItem) => void;
	addNote: () => void;
	response: (parent: NoteItem) => NoteItem;
}

interface State {
	collapseKeys: { [key: string]: string[]; };
}

@observer
export class NoteListView extends React.Component<NoteListViewProps, State> {
	public state: State = {
		collapseKeys: { 'root': [] },
	};

	private optionsType = [
		{ value: 'Warning', label: 'Warning' },
		{ value: 'Urgent', label: 'Urgent' },
		{ value: 'Information', label: 'Information' },
	];

	private defaultActiveKey: { [key: string]: string[]; };

	private rendenChildNote(note: NoteItem, parent: NoteItem) {
		const mode = this.props.parentMode;

		return (
			<div>
				{
					!note.id.startsWith("create") && <Button
						icon="delete"
						disabled={note.userName != this.props.identityService.username || this.props.parentMode == 'display'}
						onClick={() => {
							this.props.deleteNote(note, parent);
							this.forceUpdate();
						}}
					>
						Delete
					</Button>
				}
				<div style={{ float: "right" }}>
					<VisibilityEditorView
						disabled={this.props.parentMode == 'display' ? true : false}
						label={null}
						model={note.visibility}
					/>
				</div>
				<Row gutter={16}>
					<Col xs={24}>
						<TextView
							mode={mode}
							label="Title"
							value={note.title}
							placeholder="Enter a title..."
							onChanged={newVal => { note.title = newVal; this.forceUpdate(); }}
						/>
					</Col>
					<Col xs={24} lg={8}>
						<DropdownView
							required
							disabled={mode == 'display'}
							label="Type:"
							model={note.type}
							onChanged={(item) => note.type = item.value}
							options={this.optionsType}
						/>
					</Col>
					<Col xs={24} lg={8}>
						<TextView
							mode="display"
							label="User"
							value={note.userName}
						/>
					</Col>
					<Col xs={24} lg={8}>
						<DateView
							label="Creation Date"
							mode="display"
							value={note.creationDate}
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={24}>
						<RichTextView
							containerClassName="wysiwyg-editor-wrap-content"
							label="Note Text"
							value={note.html}
							onChanged={(html) => {
								note.html = html;
							}}
							mode={mode}
						/>
					</Col>
				</Row>
			</div>
		);
	}

	private renderNote = (note: NoteItem, parent: NoteItem) => {
		if (note.children == null || note.children.length == 0) {
			return (
				<Panel
					header={note.title || "Enter a title..."}
					key={note.id}>
					{this.rendenChildNote(note, parent)}
				</Panel>
			);
		} else {
			const children = [];
			const { collapseKeys } = this.state;
			for (const child of note.children) {

				if (this.defaultActiveKey[note.id] == null)
					this.defaultActiveKey[note.id] = [];
				if (collapseKeys[note.id] == null) {
					collapseKeys[note.id] = [];
					this.setState({
						collapseKeys: collapseKeys
					});
				}

				this.defaultActiveKey[note.id].push(child.id);
				const activesKeys = this.defaultActiveKey[note.id].filter(k => !collapseKeys[note.id].some(x => x == k));
				children.push(
					<Collapse
						key={child.id}
						bordered={false}
						activeKey={activesKeys}
						onChange={(key) => { this.onchangePanel(key, note.id) }}
					>
						{this.renderNote(child, note)}
					</Collapse>
				);
			}

			return (
				<Panel
					header={note.title || "Enter a title..."}
					key={note.id}
				>
					{this.rendenChildNote(note, parent)}
					{children}
				</Panel>
			);
		}
	};

	private onchangePanel = (key: string | string[], parentKey: string) => {
		const { collapseKeys } = this.state;
		if (isArrayLike(key)) {
			collapseKeys[parentKey] = this.defaultActiveKey[parentKey].filter(k => !key.some(x => x == k));
		} else if (key != null || key != '') {
			collapseKeys[parentKey] = this.defaultActiveKey[parentKey].filter(k => key != k);
		}

		this.setState({
			collapseKeys: collapseKeys
		});
	}

	public render() {
		const { model } = this.props;
		const collapseNote = [];
		this.defaultActiveKey = { 'root': [] };

		for (const note of model) {
			this.defaultActiveKey['root'].push(note.id)
			collapseNote.push(this.renderNote(note, note));
		}

		const activesKeys = this.defaultActiveKey['root'].filter(k => !this.state.collapseKeys['root'].some(x => x == k));
		return (
			<div>
				<Button
					key="add"
					type="primary"
					disabled={this.props.parentMode == 'display'}
					icon="plus"
					onClick={this.props.addNote}
				>
					Add
				</Button>
				<Collapse
					key="root"
					bordered={false}
					activeKey={activesKeys}
					onChange={(key) => { this.onchangePanel(key, 'root') }}
				>
					{collapseNote}
				</Collapse>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/notes/list/note-list.view.tsx